export const MAX_FILE_SIZE = 2 * 1024 * 1024;
export const SUPPORTED_IMAGE_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
